import { Globals } from '@/modules/Globals';

export enum Allergens {
  Altramuces = 1,
  Apio = 2,
  Cacahuates = 4,
  Crustaceos = 8,
  FrutosSecos = 16,
  Gluten = 32,
  Huevos = 64,
  Lacteos = 128,
  Moluscos = 256,
  Mostaza = 512,
  Pescado = 1024,
  Sesamo = 2048,
  Soja = 4096,
  Sulfitos = 8192,
}

/*for (let a in Allergens) {
  const val = parseInt(a, 10);
  const isNumber = val >= 0;
  if (isNumber) {
    const allergen = {
      name: Allergens[a],
      picture: Allergens[a].toLowerCase(),
      id: val
    };
    ALLERGENS.push(allergen);
  }
}*/
export interface IAllergen {
  name: string;
  picturePath: string;
  id: number;
}

export const ALLERGENS: IAllergen[] = [];

for (let a in Allergens) {
  const val = parseInt(a, 10);
  const isNumber = val >= 0;
  if (isNumber) {
    const allergen = {
      name: Allergens[a],
      picturePath: `${Globals.uploadsPath}/static/alergenos/${Allergens[
        a
      ].toLowerCase()}.png`,
      id: val,
    };
    ALLERGENS.push(allergen);
  }
}

export const ALLERGENS_MAP = new Map<number, IAllergen>(
  ALLERGENS.map((a) => [a.id, a])
);
